import {
  combineReducers,
  type Reducer,
  type UnknownAction
} from "redux";
import menu from "./menu/reducer";
import settings from "./settings/reducer";
import type { RootState } from "./state";

const rootReducer = combineReducers({
  menu,
  settings
}) as Reducer<RootState, UnknownAction, Partial<RootState>>;

export default rootReducer;
